export const OFICINAS_NO_PERMITIDAS = ["Palma (Cecili Metel)"]